import React from 'react';
import {Link} from "react-router-dom";

import {RtButton} from '../../../server/routes/route-types.js'

interface Button extends RtButton {
    IsDomainList?: boolean;
}

interface ListButtonProps {
    button: Button | undefined;
}

export default function ListButton({button}: ListButtonProps) {

	if (!button) return null;

	return (
		<>
			<Link 
				to={button.Href}
				className="button button-secondary" 
				title={button.Title} 
				rel="noopener nofollow" 
			>
				{button.Text}
			</Link>
			<br />
			{/*
				true == button.IsDomainList &&
					<>Flat price per the report, subscription is not required.</>
			*/}
		</>
	)
} 
